import {
  Box,
  Heading,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
  VStack,
  Button,
} from "@chakra-ui/react";

import { ReactComponent as SuccessCheckboxIcon } from "assets/svg/successCheckbox.svg";
// import { Button } from "../../../components";

const UploadSuccessModal = ({ isOpen, onClose, message, amount }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent maxW={300} bg="#03A438" isCentered borderRadius="24px">
        <ModalBody>
          <Box as={VStack} pt="40px" color="white" textAlign="center">
            <Box as={SuccessCheckboxIcon} fontSize="100px" mb="20px" />
            <Heading fontSize="xl" fontWeight="500" letterSpacing="-1px">
              Uploaded
            </Heading>
            <Text m="0" letterSpacing="-1px">
              Thank you for uploading. Your request is pending.
            </Text>
          </Box>
        </ModalBody>

        <ModalFooter as={HStack} justify="flex-end">
          <Button
            onClick={onClose}
            maxW="60px"
            size="sm"
            color="white"
            variant="ghost"
            border="1px solid transparent"
            _hover={{
              bg: "transparent",
            }}
            _active={{
              bg: "transparent",
            }}
            _focus={{
              borderColor: "#06C344",
              boxShadow: "0 0 0 3px #06C3448f",
            }}
          >
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default UploadSuccessModal;
